import { Text, CoteraLink } from '@cotera/client/app/components/ui';
import { LogoComponent } from '@cotera/client/app/components/app';
import { LegacyLayout } from '../../layout';

export const UnauthorizedPage = () => {
  return (
    <LegacyLayout>
      <div className="h-full flex-1 flex flex-col justify-center items-center mr-8">
        <div className="h-[20px] w-[20px] mb-16">
          <LogoComponent />
        </div>
        <Text.Caption className="text-primary-text font-bold text-2xl mb-3">
          401
        </Text.Caption>
        <Text.Title type="title" className="mb-3 capitalize">
          Unauthorized
        </Text.Title>
        <Text.Caption className="mb-6">
          It appears you dont have permission to access the resource you were
          looking for.
        </Text.Caption>

        <CoteraLink to="/">
          Got back home <span aria-hidden="true"> &rarr;</span>
        </CoteraLink>
      </div>
    </LegacyLayout>
  );
};
